import {Component, OnInit} from '@angular/core';
import {HelperProvider} from '../providers/helper.provider';
import {Page} from '../model/page';
import {RestService} from '../providers/rest.service';
import {Sube} from '../model/sube';
import {Router} from '@angular/router';

@Component({
  selector: 'app-subeler',
  templateUrl: './subeler.component.html',
  styleUrls: ['./subeler.component.css']
})
export class SubelerComponent implements OnInit {
  subeler: Sube[] = null;

  constructor(private helperProvider: HelperProvider,
              private restService: RestService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Subeler);

    this.getSubeler();
  }

  getSubeler() {
    this.restService.subeler().subscribe(res => {
      if (res != null) {
        this.subeler = res;
      }
    }, error => {
      this.helperProvider.showConnectionError$.next(true);
    });
  }

  kaldir(s: Sube) {
    if (confirm(`${s.isim} şubesini silmek istediğinize emin misiniz?`)) {
      this.restService.subeSil(s.id).subscribe(res => {
        if (res) {
          this.getSubeler();
        }
      });
    }
  }

  incele(s: Sube) {
    this.router.navigate(['sube'], {queryParams: {id: s.id}});
  }

  new() {
    this.router.navigate(['sube'], {queryParams: {id: '0'}});
  }
}
